import { Box, Button, Text, rem, rgba } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { ResetPasswordFormValues } from "../../hooks/useResetPasswordController";
import { FormPasswordInput } from "@/design-system/components/form/FormPasswordInput";
import { PasswordStrength } from "@/components/PasswordStrength";
import { PASSWORD_LEVELS } from "@/core/constants";
import { checkPasswordStrength } from "@/shared/utils/password";

interface ResetPasswordFormProps {
  form: UseFormReturnType<ResetPasswordFormValues>;
  loading: boolean;
  onSubmit: () => void;
}

export const ResetPasswordForm = ({
  form,
  loading,
  onSubmit,
}: ResetPasswordFormProps) => {
  const passwordInput = form.getInputProps("password");

  const passwordVal = form.values.password;
  const { isValid: isPasswordValid } = checkPasswordStrength(passwordVal);

  return (
    <form
      onSubmit={form.onSubmit(onSubmit)}
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: rem(16),
      }}>
      <FormPasswordInput
        label="Senha"
        c={rgba("var(--mantine-color-plain_text-0)", 0.5)}
        placeholder="Digite sua senha..."
        size="md"
        required
        withAsterisk={false}
        withErrorStyles={false}
        styles={{ input: { border: "none" } }}
        {...passwordInput}
      />

      <Box w={"100%"}>
        <PasswordStrength
          showStrength={form.values.password.trim().length > 0}
          levels={PASSWORD_LEVELS}
          password={passwordInput.value}
        />
      </Box>

      <FormPasswordInput
        label="Confirme sua senha"
        c={rgba("var(--mantine-color-plain_text-0)", 0.5)}
        placeholder="Digite sua senha novamente..."
        size="md"
        required
        withAsterisk={false}
        withErrorStyles={false}
        styles={{ input: { border: "none" } }}
        {...form.getInputProps("passwordConfirmation")}
      />

      <Text
        fz={14}
        mt={rem(4)}
        c={rgba("var(--mantine-color-D900-0)", 0.5)}>
        Certifique-se de memorizar ou guardar sua nova senha com segurança.
      </Text>

      <Button
        fullWidth
        mt={rem(12)}
        size="sm"
        type="submit"
        radius={rem(8)}
        loading={loading}
        disabled={!isPasswordValid || !form.isValid() || loading}
        bg={"var(--mantine-color-contrast_text-0)"}
        ff={"heading"}
        fz={16}
        fw={700}>
        Definir senha
      </Button>
    </form>
  );
};
